module.exports = __webpack_public_path__ + "img/accessory_hat_01.f2010d90.svg";